import * as Yup from 'yup'
import {BaseEntity} from '../../../shared/models/ApiModels'
import {TabOption} from '../../../shared/components/FormTabHeader'

export interface ICustomerModel extends BaseEntity {
  // Identity Information
  firstName: string
  lastName: string
  tcKimlikNo: number
  dateOfBirth: string
  placeOfBirth: string

  // Contact Information
  gsm1: string
  gsm2?: string
  emailAddress: string
  phone?: string
  address: string

  // Driver Licence Information
  drivingLicenseNo: string 
  drivingLicenseClass: string
  drivingLicenseIssueDate: string
  drivingLicenseIssuedBy: string 

  // Passport Information
  passportNumber?: string
  passportIssueDate?: string
  passportIssuedBy?: string 

  // Address Information
  businessAddress?: string
  invoiceAddress?: string
  invoiceAddressDifferent?: string
  businessPhone?: string
  registeredProvince?: string
  registeredDistrict?: string
  registeredNeighborhood?: string

  // Additional Information
  taxOffice?: string
  taxNumber?: string
  country?: string
  city?: string
  district: string
  communicationLanguage?: string
  warningMessage?: string 
  balanceVisibleBranch?: string
  corporateNumber?: string
  corporatePassword?: string  
  webDiscount?: string

  // Family Information
  motherName?: string
  fatherName?: string

  // Permission Flags
  hgsResponseType?: string
  licenseType?: string 
  licenseCountry: string 
  customerClass: string
  customerRepresentative: string  
  riskPermit?: string
  riskLimit?: string    
  specialCode?: string
  integrationCode?: string
  description?: string
  tariff?: string 
  bankInformation?: string 
  maturityDay?: string 
  reservationSource?: string
  currency?: string
  riskMessage?: string
  dealerCommissionRate?: string
  /** Servis merkezi indirimleri (%) */
  partsDiscount?: string
  laborDiscount?: string
  consumablesDiscount?: string 
  serialNo?: number 
  volumeNo?: number 
  warningTime?: string
  operationBranch?: string 
  riskMessageDate?: string  
  familySequenceNo: string
  sequenceNo?: string
  invoicePeriod?: string
  customerType: string
  stoppageType?: string
  stoppageCode?: string

  // General settings
  passive: boolean
  hideInvoiceDetail: boolean 
  smsPermission: boolean
  mailPermission: boolean
  phonePermission: boolean
  birthdayTracking: boolean

  // Card anonymization
  customerCardAnonymized: boolean
  rentalCardAnonymized: boolean
  reservationCardAnonymized: boolean
  invoiceCardAnonymized: boolean
  cashboxCardAnonymized: boolean
  trafficHgsCardAnonymized: boolean

  // Risk & special conditions
  carNotAllowed: boolean
  ageLicenseFree: boolean
  showRenterOnInvoice: boolean
  branchSpecific: boolean
  hqCorporate: boolean
  brokerAgency: boolean
  findexRequired: boolean
}

export const initialCustomer: ICustomerModel = {
  // Basic Info
  firstName: '',
  lastName: '',
  tcKimlikNo: undefined as unknown as number,
  dateOfBirth: '',
  placeOfBirth: '',

  // Contact Info
  gsm1: '',
  gsm2: '',
  emailAddress: '',
  phone: '',
  address: '',

  // Driver Licence
  drivingLicenseNo: '', 
  drivingLicenseClass: '',
  drivingLicenseIssueDate: '',
  drivingLicenseIssuedBy: '', 

  // Passport
  passportNumber: '',
  passportIssueDate: '',
  passportIssuedBy: '',

  // Address
  businessAddress: '',
  invoiceAddress: '',
  invoiceAddressDifferent: '',
  businessPhone: '',
  registeredProvince: '',
  registeredDistrict: '',
  registeredNeighborhood: '',

  // Additional
  taxOffice: '',
  taxNumber: '',
  country: '',
  city: '',
  district: '',
  communicationLanguage: '',
  warningMessage: '', 
  balanceVisibleBranch: '',
  corporateNumber: '',
  corporatePassword: '',  
  webDiscount: '',

  // Family
  motherName: '',
  fatherName: '',

  // Permission Flags
  hgsResponseType: '',
  licenseType: '', 
  licenseCountry: '',  
  customerClass: '',
  customerRepresentative: '',

  invoicePeriod: '',
  customerType: 'INDIVIDUAL',
  stoppageType: '',
  stoppageCode: '',

  // Risk / Finance  
  riskPermit: '',
  riskLimit: '',    
  specialCode: '',
  integrationCode: '',
  description: '',
  tariff: '', 
  bankInformation: '',
  maturityDay: '', 
  reservationSource: '',
  currency: '',
  riskMessage: '',
  dealerCommissionRate: '',
  partsDiscount: '',
  laborDiscount: '',
  consumablesDiscount: '', 
  serialNo: 0, 
  volumeNo: 0, 
  warningTime: '',
  operationBranch: '', 
  riskMessageDate: '',  
  familySequenceNo: '',
  sequenceNo: '',
  passive: false,
  hideInvoiceDetail: false,
  smsPermission: false,
  mailPermission: false,
  phonePermission: false,
  birthdayTracking: false,
  customerCardAnonymized: false,
  rentalCardAnonymized: false,
  reservationCardAnonymized: false,
  invoiceCardAnonymized: false,
  cashboxCardAnonymized: false,
  trafficHgsCardAnonymized: false,
  carNotAllowed: false,
  ageLicenseFree: false,
  showRenterOnInvoice: false,
  branchSpecific: false,
  hqCorporate: false,
  brokerAgency: false,
  findexRequired: false,
}

export const validationCustomer = Yup.object().shape({
  // Basic Info
  firstName: Yup.string().required('Ad zorunludur'),
  lastName: Yup.string().required('Soyad zorunludur'),
  tcKimlikNo: Yup.string()
    .matches(/^[0-9]{11}$/, 'TC Kimlik No 11 haneli olmalı')
    .required('TC Kimlik No zorunludur'),
  dateOfBirth: Yup.date().required('Doğum tarihi zorunludur'), 

  // Contact
  gsm1: Yup.string().required('GSM zorunludur'),
  emailAddress: Yup.string().email('Geçerli bir e-posta girin').required('E-posta zorunludur'),
  address: Yup.string().required('Adres zorunludur'),

  // Driver Licence
  drivingLicenseNo: Yup.string().required('Ehliyet no zorunludur'),
  drivingLicenseClass: Yup.string().required('Ehliyet sınıfı zorunludur'),
  drivingLicenseIssueDate: Yup.date().required('Ehliyet veriliş tarihi zorunludur'),
  drivingLicenseIssuedBy: Yup.string().required('Ehliyet veren kurum zorunludur'),
  licenseCountry: Yup.string().required('Ehliyet ülke bilgisi zorunludur'),
 
})

export const customerTabs: TabOption<
  'indivual' | 'identity' | 'detail' | 'permission' | 'other'
>[] = [
  {key: 'indivual', title: 'Bireysel', icon: 'bi bi-car-front'},
  {key: 'identity', title: 'Ehliyet & Pasaport', icon: 'bi bi-clipboard-check'},
  {key: 'detail', title: 'Detay', icon: 'bi bi-shield-check'},
  {key: 'permission', title: 'İzinler', icon: 'bi bi-exclamation-triangle'},
  {key: 'other', title: 'Diğer Adres & Kimlik', icon: 'bi bi-folder-image'},
]

export const customerSubTabs: TabOption<'address' | 'identity'>[] = [
  {key: 'address', title: 'Diğer Adres Bilgileri', icon: 'bi bi-car-front'},
  {key: 'identity', title: 'Kimlik Bilgileri', icon: 'bi bi-clipboard-check'},
]
